import '@/assets/css/global.css'
import '@/assets/css/ui.css'

import Vue from 'vue'
import App from './index.vue'

import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);

let mainApp = null;

import '@/plugins/validate.js'
import '@/directives/index'

import vuescroll from 'vuescroll';
Vue.use(vuescroll, {
  ops: {
    rail: {
        opacity: 0.6,
        background : '#f3d2c5',
        size: '6px',
        gutterOfSide : '0px',
    },
    bar: {
        background: '#c2393f',
        keepShow : true,
        size: '6px',
    }
  }, // 在这里设置全局默认配置
  name: 'vuescroll' // 在这里自定义组件名字，默认是vueScroll 
});


//wx_share
import wx from '@/assets/js/wxapi.jsonp.js';

import {$get,$post} from "@/assets/js/axios.http.js"
Vue.prototype.$get = $get
Vue.prototype.$post = $post

//axios
import axios from 'axios';
Vue.prototype.$axios = axios;

import GLOBAL from '@/assets/js/global.js'
Vue.prototype.$global = GLOBAL
Vue.prototype.$queryArea = GLOBAL.queryArea;

//ajxa_map
globalThis.ajax_url_map = GLOBAL.ajax_url_map;

//store
import store from "@/assets/js/store.js";
Vue.prototype.$store = store;

//clipboard
import clipboard from 'clipboard';
Vue.prototype.clipboard = clipboard;

//Qr
import QRcode from '@/components/QrCode'
Vue.use(QRcode);

//FREE
import Free_login from '@/assets/js/freeLogin.js';

//login
import mslogin from '@/assets/js/msLogin.js';
Vue.prototype.$mslogin = mslogin;
mslogin.defaults.loginUrl = GLOBAL.ajax_url_map.login;

//user_info
import User_info from '@/components/userinfo.vue';
Vue.component('user-info', User_info);

//item_view
import gameItem from '@/components/itemview.vue'
Vue.component('game-item', gameItem);

//utils
import utils from '@/assets/js/utils.js';
Object.keys(utils).forEach(key => {
  Vue.prototype[key] = utils[key]
})

Vue.prototype.$update_evt = function (data) {
  mainApp.user_init();
};

Vue.prototype.$task_render = function (data) {
    mainApp.task_init();
};

Vue.prototype.$clear_code = function(id,type){
  mainApp.$refs.app.code = '';
};

mainApp = new Vue({
    el: '#app',
    components: {
      App
    },
    template: '<App ref="app" :ready="ready" :ua="ua" :evt_info="evt_info" :login="login"/>',
    data() {
      return {
        ua: {},
        evt_info: {},
        code: '',
        name: null,
        login: 0, //登陆
        aid: 0, //大区id
        account_type: 'pc',
        isLoading: false,
        ready: false, //通信阀门
        share_id : 'ME21',
        key : '', 
        token : '',        
      }
    },
    created() {
      var _this = this;

      let token = GLOBAL.getQueryVariable('authorization') || localStorage.getItem("token");
      _this.token = token;
      
      let code = GLOBAL.getQueryVariable('code') || localStorage.getItem("code");

      if(GLOBAL.getQueryVariable('code')){
        //this.$store.commit("$_setCode", GLOBAL.getQueryVariable('code'));
        localStorage.setItem('code', code);
        //window.history.pushState({}, 0, GLOBAL.domain);
      }
      
      this.key = code;

      if (token) {
        localStorage.setItem('token', token);
        _this.$store.commit("$_setToken", token);
      }

      window.history.pushState({}, 0, GLOBAL.domain);
    },
    mounted (){
        this.get_user_info();
        wx.wxInit({
          title: GLOBAL.wx_share_text.title, // 分享标题
          desc: GLOBAL.wx_share_text.desc, // 分享描述
          link: GLOBAL.domain, // 分享链接
          imgUrl: GLOBAL.wx_share_text.imgUrl, // 分享图标            
        });         
    },
    methods: {
      get_user_info() {
        // 调用免登录接口，进行免登录验证
        //TODO 梦平台免登录
        let _this = this;

        this.ua.uid = this.ua.uid || 0;

        Free_login.free_login_lazy(
          this.$store.state.userinfo.accountid, {
            mplat: ajax_url_map.mplat,
            kd: ajax_url_map.free,
          },
          function (response) {
            if (typeof response !== 'undefined') {
              _this.token = response.data ? response.data : response;
              localStorage.setItem('token', _this.token);
              _this.$store.commit("$_setToken", _this.token);              
            }
            _this.user_init();

          }
        );       
      },      
      user_init (){
        this.$post(ajax_url_map.userinfo,{
            success : (data) => {
              this.$store.commit("$_setUserinfo", data.data);
              this.$store.commit("$_setLogin", 1);

              this.task_init();
              if(localStorage.getItem("code"))this.$apply_modal({code : this.key});             
            },
            error : (data) => {
                this.task_init();
                if(data.code != 401 && data.code != 402)this.$toast(data.message);
                if(localStorage.getItem("code"))this.$apply_modal({code : this.key});

                if(data.data){
                  this.$store.commit("$_setUserinfo", data.data);
                  this.$store.commit("$_setLogin", 1);
                }
                if(data.code == 402 && !localStorage.getItem("code")){
                  this.$bind_modal();
                }
            },
        })
      },
      task_init(){
        this.$get(ajax_url_map.taskinfo,{
            success : (data) => {
                this.ready = true;
                this.$store.commit("$_setTask", data.data);
            },
            error : (data) => {
                this.ready = true;
                data.data && this.$store.commit("$_setTask", data.data);
            }
        })
      },   
    },
  })




// WEBPACK FOOTER //
// ./src/page/index/index.js